import React, { useEffect, useState } from "react";
import { Table, Row, Col, Checkbox, Popconfirm, Divider, Modal, Form, message, Alert } from "antd";
import { CardContainer } from "../../../components/Card/CardContainer";
import {
  CalendarOutlined,
  DeleteOutlined,
  SearchOutlined,
  UnorderedListOutlined,
  VerticalAlignBottomOutlined,
} from "@ant-design/icons";
import Button from "../../../components/Button/Button";
import Input from "../../../components/Input/Input";
import { useNavigate } from "react-router-dom";
import { excelMutiCo, getCustomerCreditMemoList } from "../../../datasource/CreditMemoDatasource";
import { FlexCol } from "../../../components/Container/Container";
import Text from "../../../components/Text/Text";
import color from "../../../resource/color";
import { priceFormatter } from "../../../utility/Formatter";
import { getZones } from "../../../datasource/CustomerDatasource";
import Select from "../../../components/Select/Select";
import { AlignType } from "rc-table/lib/interface";
import Permission, { checkPermission } from "../../../components/Permission/Permission";
import { useRecoilValue } from "recoil";
import { roleAtom } from "../../../store/RoleAtom";
import { ActionBtn } from "../../../components/Button/TableActionButton";
import DatePicker from "../../../components/DatePicker/DatePicker";
import { useNotificationContext } from "../../../context/NotificationProvider";
import dayjs from "dayjs";

type FixedType = "left" | "right" | boolean;

export const CustomerDiscountListPage: React.FC = () => {
  const pageSize = 10;
  const userProfile = JSON.parse(localStorage.getItem("profile")!);
  const { company, firstname, lastname } = userProfile;
  const roleData = useRecoilValue(roleAtom);
  const isExcel = checkPermission(["manageConditionStore", "excel"], roleData);
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const startDateWatch = Form.useWatch("startDate", form);
  const endDateWatch = Form.useWatch("endDate", form);
  const [keyword, setKeyword] = useState("");
  const [statusFilter, setStatusFilter] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [dataState, setDataState] = useState<any>({
    count: 0,
    count_status: [],
    data: [],
  });
  const [zones, setZones] = useState<any>();
  const [searchZone, setSearchZone] = useState<any>();
  const [shopSelected, setShopSelected] = useState<any[]>([]);
  const [modalMutiSelect, setModalMutiSelect] = useState<boolean>(false);
  const [deleteConfirmId, setDeleteConfirmId] = useState<string | null>(null);
  const { startUploadProcess } = useNotificationContext();
  const [progressValue, setProgressValue] = useState(0);
  const [isExporting, setIsExporting] = useState(false);

  useEffect(() => {
    if (!loading) fetchData();
    fetchZone();
  }, [keyword, statusFilter, page, searchZone]);

  const resetPage = () => setPage(1);

  const fetchData = async () => {
    try {
      setLoading(true);
      const { data, count, count_status } = await getCustomerCreditMemoList({
        company,
        creditMemoShopStatus: statusFilter,
        searchText: keyword,
        take: pageSize,
        page,
        zone: searchZone,
      });
      const mapData = data.map((d: any) => {
        const isChecked = shopSelected.find((p) => p.customer_company_id === d.customer_company_id);
        return {
          ...d,
          isChecked: isChecked,
        };
      });
      setDataState({
        data: mapData || [],
        count,
        count_status,
      });
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const fetchZone = async () => {
    const zoneData = await getZones(company);
    const data = zoneData.map((item: any) => {
      return {
        label: item.zoneName,
        value: item.zoneName,
        key: item.zoneId,
      };
    });
    setZones(data);
  };
  const PageTitle = () => {
    return (
      <Row justify={"space-between"} gutter={8}>
        <Col span={company === "ICPF" ? (isExcel ? 12 : 15) : isExcel ? 8 : 11}>
          <div>
            <span
              className='card-label font-weight-bolder text-dark'
              style={{ fontSize: 20, fontWeight: "bold" }}
            >
              ส่วนลดดูแลราคารายร้าน
            </span>
          </div>
        </Col>
        <Col span={4}>
          <Select
            allowClear
            value={searchZone}
            placeholder='เขตร้านค้า : ทั้งหมด'
            data={zones}
            style={{ width: "100%" }}
            onChange={(e) => setSearchZone(e)}
          />
        </Col>
        <Col span={5}>
          <Input
            allowClear
            placeholder='ค้นหาร้านค้า/รหัสร้านค้า'
            prefix={<SearchOutlined style={{ color: "grey" }} />}
            defaultValue={keyword}
            onPressEnter={(e: any) => {
              const value = (e.target as HTMLTextAreaElement).value;
              setKeyword(value);
              resetPage();
            }}
            onChange={(e: any) => {
              const value = (e.target as HTMLInputElement).value;
              if (!value) {
                setKeyword("");
                resetPage();
              }
            }}
            style={{ width: "100%" }}
          />
        </Col>
        {company !== "ICPF" && (
          <Permission permission={["manageConditionStore", "create"]}>
            <Col span={4}>
              <Button
                type='primary'
                title='+ สร้างส่วนลดดูแลราคา'
                height={40}
                onClick={() => navigate(`/discount/create`)}
              />
            </Col>
          </Permission>
        )}
        <Permission permission={["manageConditionStore", "excel"]}>
          <Col>
            <Button
              type='primary'
              typeButton={shopSelected.length > 0 ? "primary" : "disabled"}
              title={
                <>
                  <VerticalAlignBottomOutlined style={{ fontSize: "18px" }} /> Export (
                  {shopSelected.length}/5)
                </>
              }
              height={40}
              onClick={() => shopSelected.length && (setModalMutiSelect(true), form.resetFields())}
            />
          </Col>
        </Permission>
      </Row>
    );
  };
  const selectedOne = (e: boolean, cusComId: string) => {
    const newData = dataState.data.map((item: any) =>
      item.customer_company_id === cusComId ? { ...item, isChecked: e } : item,
    );
    setDataState({ ...dataState, data: newData });
    setShopSelected((prev) => {
      if (!e) {
        return prev.filter((item) => item.customer_company_id !== cusComId);
      }

      const selectedItem = newData.find((item) => item.customer_company_id === cusComId);
      if (!selectedItem) {
        return prev;
      }

      return Array.from(
        new Map([...prev, selectedItem].map((item) => [item.customer_company_id, item])).values(),
      );
    });
  };
  const resetSelected = () => {
    const mapData = dataState.data.map((d: any) => {
      return {
        ...d,
        isChecked: false,
      };
    });
    setDataState({
      data: mapData,
      count: dataState.count,
      count_status: dataState.count_status,
    });
    setShopSelected([]);
  };
  const exportMutiExcel = async () => {
    try {
      await form.validateFields().then(async (values) => {
        setIsExporting(true);
        setModalMutiSelect(false);
        const { startDate, endDate } = values;
        const cusIdList = shopSelected.map((p) => p.customer_company_id);
        const startDateStr = dayjs(startDate).format("YYYY-MM-DD");
        const endDateStr = dayjs(endDate).format("YYYY-MM-DD");
        const params = {
          customerCompanyIds: cusIdList,
          startDate: startDateStr,
          endDate: endDateStr,
        };
        try {
          const config = await excelMutiCo(params);
          if (config) {
            const blob = new Blob([config], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            startUploadProcess(
              "",
              progressValue,
              setProgressValue,
              {
                placement: "bottomRight",
                duration: 2,
                label: "กำลังเตรียมไฟล์ของคุณ รอสักครู่!",
                progressInterval: 900,
              },
              async () => {
                try {
                  const a = document.createElement("a");
                  a.href = URL.createObjectURL(blob);
                  a.download = `co-${new Date()
                    .toLocaleDateString("us-EN", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })
                    .replace(/\//g, "-")}.xlsx`;
                  document.body.appendChild(a);
                  a.click();
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(a.href);
                  // formatFileSize(blob.size);
                } catch (error) {
                  message.error("Export Excel ไม่สำเร็จ");
                } finally {
                  setModalMutiSelect(false);
                  setIsExporting(false);
                }
              },
            );
          }
        } catch (error) {
          console.error("Error submitting report:", error);
        } finally {
          resetSelected();
          setModalMutiSelect(false);
        }
      });
    } catch (e: any) {
      console.log(e);
    }
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "4%",
      hidden: !isExcel,
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol align='center'>
              <Checkbox
                checked={row.isChecked}
                onChange={(e) => selectedOne(e.target.checked, row.customer_company_id)}
                disabled={shopSelected.length === 5 && !row.isChecked}
              />
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "Customer No",
      dataIndex: "customer_no",
      key: "customer_no",
      width: "15%",
    },
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customer_name",
      key: "customername",
      width: "25%",
      render: (value: string, row: any) => {
        return (
          <>
            <FlexCol>
              <Text level={6}>{value}</Text>
              <Text color='Text3' level={6}>
                {row.province ? "จ." + row.province : "-"}
              </Text>
            </FlexCol>
          </>
        );
      },
    },
    {
      title: "ชื่อเจ้าของร้าน",
      dataIndex: "firstname",
      key: "name",
      width: "20%",
      render: (firstname: string, row: any) => {
        return (
          <>
            <FlexCol>
              <Text level={6}>{`${firstname || "-"} ${row.lastname || ""}`}</Text>
            </FlexCol>
          </>
        );
      },
    },
    {
      title: "เขต",
      dataIndex: "zone",
      key: "zone",
      width: "10%",
    },
    {
      title: <div style={{ display: "flex", justifyContent: "flex-start" }}>ยอดคงเหลือ</div>,
      dataIndex: "balance",
      key: "balance",
      width: "15%",
      align: "right" as AlignType,
      render: (value: string, row: any) => {
        return priceFormatter(value, undefined, true);
      },
    },
    {
      title: "จัดการ",
      dataIndex: "action",
      key: "action",
      width: "15%",
      fixed: "right" as FixedType | undefined,
      hidden: !checkPermission(["manageConditionStore", "view"], roleData),
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <>
              <div className='d-flex flex-row justify-content-between'>
                <div
                  className='btn btn-icon btn-light btn-hover-primary btn-sm'
                  onClick={() => navigate("/discount/customerDetail/" + row.customer_company_id)}
                >
                  <span className='svg-icon svg-icon-primary svg-icon-2x'>
                    <UnorderedListOutlined style={{ color: color["primary"] }} />
                  </span>
                </div>
              </div>
            </>
          ),
        };
      },
    },
  ].filter((item) => !item.hidden);

  return (
    <>
      <CardContainer>
        <PageTitle />
        <br />
        <Table
          className='rounded-lg'
          columns={columns}
          dataSource={dataState.data}
          pagination={{
            showSizeChanger: false,
            pageSize,
            current: page,
            onChange: (page) => setPage(page),
            position: ["bottomCenter"],
          }}
          size='large'
          tableLayout='fixed'
          loading={loading}
        />
      </CardContainer>
      {isExporting && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(128, 128, 128, 0.18)",
            cursor: "not-allowed",
            zIndex: 999,
          }}
        />
      )}
      {modalMutiSelect && (
        <Modal
          open={modalMutiSelect}
          footer={false}
          width={1000}
          onCancel={() => setModalMutiSelect(false)}
          centered
        >
          <Text level={4} fontWeight={600}>
            ร้านค้าที่ต้องการ Export จำนวน {shopSelected.length} รายการ
          </Text>
          <Divider style={{ margin: "12px 0px 0px 12px", paddingBottom: "15px" }} />
          <Row justify='end' gutter={8} style={{ paddingBottom: "10px" }}>
            <Col>
              <Popconfirm
                placement='top'
                title={
                  <Row justify={"space-between"} gutter={8}>
                    <Col>
                      <Button
                        size='small'
                        title={
                          <Text level={6} color='primary'>
                            ยกเลิก
                          </Text>
                        }
                        typeButton='primary-light'
                        height={25}
                        style={{ padding: "0 12px" }}
                        onClick={() => resetSelected()}
                      />
                    </Col>
                    <Col>
                      <Button
                        size='small'
                        title={
                          <Text level={6} color='white'>
                            ลบ
                          </Text>
                        }
                        typeButton='danger'
                        height={25}
                        style={{ padding: "0 12px" }}
                        onClick={() => {
                          setModalMutiSelect(false);
                          resetSelected();
                        }}
                      />
                    </Col>
                  </Row>
                }
                icon={false}
                showCancel={false}
                okButtonProps={{ style: { display: "none" } }}
              >
                <Text level={6} color='primary' style={{ cursor: "pointer" }}>
                  ล้างทั้งหมด
                </Text>
              </Popconfirm>
            </Col>
          </Row>
          <Row
            justify='start'
            gutter={8}
            style={{
              padding: "8px",
              backgroundColor: color.Disable,
              borderTopLeftRadius: "10px",
              borderTopRightRadius: "10px",
            }}
          >
            <Col span={4}>
              <Text fontWeight={600}> Customer No</Text>
            </Col>
            <Col span={15}>
              <Text fontWeight={600}>ชื่อร้านค้า</Text>
            </Col>
            <Col span={3}>
              <Text fontWeight={600}>เขต</Text>
            </Col>
            <Col span={2} style={{ textAlign: "right" }}>
              <Text fontWeight={600}>จัดการ</Text>
            </Col>
          </Row>
          <div style={{ maxHeight: 400, overflowY: "auto", paddingRight: 8, paddingTop: 8 }}>
            {shopSelected.map((d: any, i: number) => (
              <Row key={i} justify='start' gutter={16} style={{ padding: "8px" }}>
                <Col span={4}>
                  <Text>{d.customer_no}</Text>
                </Col>
                <Col span={15}>
                  <Text>{d.customer_name}</Text>
                </Col>
                <Col span={3}>
                  <Text>{d.zone}</Text>
                </Col>
                <Col span={2} style={{ textAlign: "right" }}>
                  <Popconfirm
                    placement='top'
                    open={deleteConfirmId === d.customer_company_id}
                    onOpenChange={(open) => setDeleteConfirmId(open ? d.customer_company_id : null)}
                    title={
                      <Row justify={"space-between"} gutter={8}>
                        <Col>
                          <Button
                            size='small'
                            title={
                              <Text level={6} color='primary'>
                                ยกเลิก
                              </Text>
                            }
                            typeButton='primary-light'
                            height={25}
                            style={{ padding: "0 12px" }}
                            onClick={() => setDeleteConfirmId(null)}
                          />
                        </Col>
                        <Col>
                          <Button
                            size='small'
                            title={
                              <Text level={6} color='white'>
                                ลบ
                              </Text>
                            }
                            typeButton='danger'
                            height={25}
                            style={{ padding: "0 12px" }}
                            onClick={() => {
                              selectedOne(false, d.customer_company_id);
                              setDeleteConfirmId(null);
                              if (shopSelected.length === 1) {
                                setModalMutiSelect(false);
                              }
                            }}
                          />
                        </Col>
                      </Row>
                    }
                    icon={false}
                    showCancel={false}
                    okButtonProps={{ style: { display: "none" } }}
                  >
                    <ActionBtn
                      icon={
                        <DeleteOutlined
                          style={{ color: color.error }}
                          //onClick={() => selectedOne(false, d.customer_company_id)}
                        />
                      }
                    />
                  </Popconfirm>
                </Col>
              </Row>
            ))}
          </div>
          <Form form={form} layout='vertical'>
            <Row justify={"space-around"} gutter={8} style={{ padding: "5px" }}>
              <Col span={12}>
                <Form.Item
                  name='startDate'
                  label='วันที่เริ่มต้น'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดเลือกวันที่เริ่มต้น",
                    },
                  ]}
                >
                  <DatePicker
                    suffixIcon={<CalendarOutlined />}
                    disabledDate={(current) =>
                      current &&
                      (current.isBefore(dayjs().subtract(3, "year").startOf("year")) ||
                        current.isAfter(
                          endDateWatch ? dayjs(endDateWatch).endOf("day") : dayjs().endOf("day"),
                        ))
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name='endDate'
                  label='วันที่สิ้นสุด'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดเลือกวันที่สิ้นสุด",
                    },
                  ]}
                >
                  <DatePicker
                    suffixIcon={<CalendarOutlined />}
                    disabledDate={(current) =>
                      current &&
                      (current.isBefore(
                        startDateWatch
                          ? dayjs(startDateWatch).startOf("day")
                          : dayjs().subtract(3, "year").startOf("year"),
                      ) ||
                        current.isAfter(dayjs().endOf("day")))
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Form>
          <Alert
            message='หมายเหตุ สามารถเลือกช่วงวันที่ย้อนหลังได้ไม่เกิน 3 ปี'
            type='info'
            showIcon
          />
          <Divider />
          <Row gutter={16} justify={"end"}>
            <Col span={4}>
              <Button
                size='small'
                title='ยกเลิก'
                typeButton='primary-light'
                style={{
                  width: "100%",
                  height: "32px",
                  lineHeight: "32px",
                  padding: "0 16px",
                }}
                onClick={() => setModalMutiSelect(false)}
              />
            </Col>
            <Col span={4}>
              <Button
                size='small'
                title='Export'
                typeButton={"primary"}
                style={{
                  width: "100%",
                  height: "32px",
                  lineHeight: "32px",
                  padding: "0 16px",
                }}
                onClick={() => {
                  exportMutiExcel();
                }}
              />
            </Col>
          </Row>
        </Modal>
      )}
    </>
  );
};
